import { render, staticRenderFns } from "./PopupPvo.vue?vue&type=template&id=04649827&"
import script from "./PopupPvo.vue?vue&type=script&lang=js&"
export * from "./PopupPvo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports